import React from "react";
import { Modal, ModalBody, ModalHeader, Alert, Button } from "reactstrap";
// import QRCode from "qrcode.react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";

const ModalQrCode = ({ isOpen, toggle, qrData, valor }) => {
  const formatCurrency = (value) => {
    if (!value) return "R$ 0,00";
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>QR Code PIX</ModalHeader>
      <ModalBody>
        {/* TEMPORÁRIO: Exibindo texto ao invés do QR Code */}
        <div className="p-3 bg-soft-warning">
          <h6 className="text-center mb-2">Chave Pix</h6>
          <div
            className="p-2 bg-white rounded text-center"
            style={{ wordBreak: "break-all" }}
          >
            <code>{qrData}</code>
          </div>
        </div>
        {/* ORIGINAL: QR Code com duração
        <div
          className="p-3 bg-soft-warning"
          style={{ textAlign: "center" }}
        >
          <QRCode value={qrData} size={256} />
          <small className="text-muted mt-3 d-block">
            <i>QR Code de duração de 1 hora</i>
          </small>
        </div>
        */}

        <div className="p-3 pb-0">
          <Alert color="warning" className="mb-0 py-2">
            <small>
              <strong>Valor do PIX: {formatCurrency(valor)}</strong>
              <br />
              Envie exatamente este valor para evitar problemas na identificação do pagamento.
            </small>
          </Alert>
        </div>

        <div className="p-3">
          <div className="mt-3 pt-2">
            <CopyToClipboard text={qrData}>
              <Button
                type="button"
                color="success"
                className="w-100"
                onClick={() =>
                  toast.success("Copiado para área de transferência!")
                }
              >
                <i className="bx bx-copy bx-xs"></i>
                Pix Copia e Cola
              </Button>
            </CopyToClipboard>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ModalQrCode;
